import { AppLink } from "@/shared/components/AppLink";
import styles from "./Button.module.css";
import type { ButtonProps } from "./Button.types";

export function Button({
  children,
  variant = "primary",
  href,
  block = false,
  className,
  ...rest
}: ButtonProps) {
  const classes = [styles.button, styles[variant], block && styles.block, className]
    .filter(Boolean)
    .join(" ");

  if (href) {
    return (
      <AppLink href={href} className={classes}>
        {children}
      </AppLink>
    );
  }

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
}
